<div>
  <app-by-year-filter *ngIf="years"
    [years]="years"
    [categories]="categories"
    (loadCategories)="loadCategories($event)"
    (search)="searchData($event)">
  </app-by-year-filter>
  <mat-divider></mat-divider>
  <app-by-year-bar-chart
    [title]="text"
    [subtitle]="subtitle"
    [displayUnits]="displayUnits"
    [countries]="countries"
    [data]="data">
  </app-by-year-bar-chart>
</div>
